export function eur(n: number | string | null | undefined): string {
  // Les montants saisis au formulaire peuvent encore être des chaînes : même rendu qu'avant.
  return ((n || 0) as number).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + ' €';
}
export function getInitials(n: string): string {
  return n
    .split(' ')
    .map((x) => x[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
export function uid(): string {
  return 'x' + Math.random().toString(36).slice(2, 8);
}
export function frenchMonthLabel(m: string): string {
  // 'YYYY-MM' → 'juil. 26'
  const d = new Date(m + '-01T00:00:00Z');
  return d.toLocaleDateString('fr-FR', { month: 'short', year: '2-digit', timeZone: 'UTC' });
}
export function shortFrenchDate(iso: string): string {
  const [, m, d] = iso.split('-');
  return `${d}/${m}`;
}
export function frenchDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}
// Jour et mois d'une date ISO : '2026-10-02' → '02/10'.
export function fmtDayMonth(d: string | null | undefined): string {
  if (!d) return '';
  const [, m, j] = d.slice(0, 10).split('-');
  return `${j}/${m}`;
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}
export function fmtTs(ts: string | number | Date | null | undefined): string {
  if (!ts) return '';
  const d = new Date(ts);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} à ${p(d.getHours())}:${p(d.getMinutes())}`;
}
